import { Outlet, createFileRoute } from '@tanstack/react-router';

// Layout route for Staff Operations. The /admin parent route gates on the
// `admin` role server-side, so this subtree inherits that guard — no extra
// check here (matches admin.bi.tsx, admin.costumes.tsx, and every other
// admin.* route).
export const Route = createFileRoute('/admin/staff')({
  component: StaffRoute,
});

function StaffRoute() {
  return <Outlet />;
}
